module.exports = __webpack_public_path__ + "img/vermouth-bianco-xxl.dc4ecb1c.png";